import {
  COMPARE_HIERARCHIES,
  COMPARE_HIERARCHIES_SUCCESS,
  COMPARE_HIERARCHIES_ERROR,
  CLEAR_HIERARCHIES_RESULT,
} from '../constants/ActionsTypes'

export const compareHierarchies = (file) => ({
  type: COMPARE_HIERARCHIES,
  payload: file,
})

export const compareHierarchiesSuccess = (data) => ({
  type: COMPARE_HIERARCHIES_SUCCESS,
  payload: data,
})

export const compareHierarchiesError = (error) => ({
  type: COMPARE_HIERARCHIES_ERROR,
  payload: error,
})

export const clearHierarchiesResult = () => ({
  type: CLEAR_HIERARCHIES_RESULT,
})
